import { ref } from 'vue';
const vehicleDetails = ref();
const licencePlate = ref('');
export function useVehicleDetails() {
    const setLicencePlate = (plate) => {
        licencePlate.value = plate.toUpperCase();
    };
    const clearLicencePlate = () => {
        licencePlate.value = '';
    };
    const setVehicleDetails = (details) => {
        vehicleDetails.value = details;
    };
    const clearVehicleDetails = () => {
        vehicleDetails.value = null;
    };
    return {
        licencePlate,
        setLicencePlate,
        clearLicencePlate,
        vehicleDetails,
        setVehicleDetails,
        clearVehicleDetails
    };
}
